import { useMemo } from 'react';
import { RouteTypeEnum } from '@/api/apis/route';
import { CaseStatus } from '@/api/apis/case';
import { useDeviceTrackingQuery } from '@/queries/composer';
import { useRouteByType } from '@/queries/route-planner';
import { isAllowedStatus } from '@/utils/helpers';
import { checkTxCenterProvidersInTransit } from '@/utils/route';

type UseLocationTrackingQueryParams = {
  caseId: string;
  status: CaseStatus;
  logisticsReferenceId: string | undefined;
};

export const useLocationTrackingQuery = ({ caseId, status, logisticsReferenceId }: UseLocationTrackingQueryParams) => {
  const { data: routeData } = useRouteByType(RouteTypeEnum.Main, logisticsReferenceId);

  const showFullRoute = isAllowedStatus({
    statusFrom: CaseStatus.OrganOnOCS,
    statusTo: CaseStatus.AtTXCenter,
    currentStatus: status,
  });

  const isOnlyTxCenterProviders = useMemo(
    () => (routeData?.legs ? checkTxCenterProvidersInTransit(routeData.legs) : false),
    [routeData?.legs],
  );

  const { data, isLoading, error } = useDeviceTrackingQuery(caseId, showFullRoute && !isOnlyTxCenterProviders);

  return { data, isLoading, error, isOnlyTxCenterProviders };
};
